import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
  useCallback,
} from "react";
import { DeponieInfo } from "../api";

interface EingangsrechnungsContextType {
  checkedDeponienMap: Record<number, DeponieInfo[]>;
  setCheckedDeponien: (
    index: number,
    deponien: DeponieInfo[] | ((prev: DeponieInfo[]) => DeponieInfo[])
  ) => void;
  getCheckedDeponien: (index: number) => DeponieInfo[];
}

const EingangsrechnungsContext = createContext<
  EingangsrechnungsContextType | undefined
>(undefined);

export const EingangsrechnungProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [checkedDeponienMap, setCheckedDeponienMap] = useState<
    Record<number, DeponieInfo[]>
  >({});

  const setCheckedDeponien = useCallback(
    (
      index: number,
      deponien: DeponieInfo[] | ((prev: DeponieInfo[]) => DeponieInfo[])
    ) => {
      //Functional update, damit wir nur einen setter benötigen
      setCheckedDeponienMap((prev) => {
        const newMap = { ...prev };
        if (typeof deponien === "function") {
          newMap[index] = deponien(prev[index] || []);
        } else {
          newMap[index] = deponien;
        }
        return newMap;
      });
    },
    []
  );

  const getCheckedDeponien = useCallback(
    (index: number): DeponieInfo[] => {
      return checkedDeponienMap[index] || [];
    },
    [checkedDeponienMap]
  );

  return (
    <EingangsrechnungsContext.Provider
      value={{
        checkedDeponienMap,
        setCheckedDeponien,
        getCheckedDeponien,
      }}
    >
      {children}
    </EingangsrechnungsContext.Provider>
  );
};

export const useEingangsrechnungContext = (): EingangsrechnungsContextType => {
  const context = useContext(EingangsrechnungsContext);
  if (!context) {
    throw new Error(
      "useEingangsrechnungContext must be used within an EingangsrechnungProvider"
    );
  }
  return context;
};
